export default __webpack_public_path__ + "static/media/wooden-background.5da5ee37.png";